import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c7aca5ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c7aca5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../gitee/am-dropshipping-mb/ux/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.108.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aca5ba",
  null
  
)

export default component.exports